import { c as _c } from "react/compiler-runtime";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
import IdentitySearch, { IdentitySearchSize } from "@/components/utils/input/identity/IdentitySearch";
export default function GroupsListSearch(t0) {
  const $ = _c(35);
  const {
    identity,
    groupName,
    showIdentitySearch,
    showCreateNewGroupButton,
    showMyGroupsButton,
    setIdentity,
    setGroupName,
    onCreateNewGroup,
    onMyGroups
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getRandomObjectId();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const randomId = t1;
  let t2;
  if ($[1] !== setGroupName) {
    t2 = e => {
      setGroupName(e.target.value);
    };
    $[1] = setGroupName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onGroupNameChange = t2;
  let t3;
  if ($[3] !== identity || $[4] !== setIdentity || $[5] !== showIdentitySearch) {
    t3 = showIdentitySearch && <IdentitySearch size={IdentitySearchSize.SM} identity={identity} setIdentity={setIdentity} label="By Identity" />;
    $[3] = identity;
    $[4] = setIdentity;
    $[5] = showIdentitySearch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="tw-flex-1">{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = groupName ?? "";
  let t6;
  if ($[9] !== onGroupNameChange || $[10] !== t5) {
    t6 = <input type="text" value={t5} onChange={onGroupNameChange} id={randomId} autoComplete="off" className="tw-py-3 tw-text-sm tw-ring-iron-700 focus:tw-border-blue-500 tw-caret-primary-400 focus:tw-ring-primary-400 hover:tw-ring-iron-650 tw-form-input tw-block tw-w-full  tw-rounded-lg tw-border-0 tw-appearance-none tw-font-medium tw-border-iron-700 tw-peer tw-pl-10 tw-pr-4 tw-bg-iron-900 tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out tw-text-white" placeholder=" " />;
    $[9] = onGroupNameChange;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <svg className="tw-top-3 tw-pointer-events-none tw-absolute tw-left-3 tw-h-5 tw-w-5 tw-text-iron-300" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" /></svg>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== groupName?.length || $[14] !== setGroupName) {
    t8 = !!groupName?.length && <svg onClick={() => setGroupName(null)} aria-label="Clear group name" className="tw-top-3 tw-cursor-pointer tw-absolute tw-right-3 tw-h-5 tw-w-5 tw-text-iron-300" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 7L7 17M7 7L17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[13] = groupName?.length;
    $[14] = setGroupName;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <label htmlFor={randomId} className={"tw-text-sm tw-absolute tw-cursor-text tw-font-medium tw-text-iron-500 tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-z-10 tw-origin-[0] tw-bg-iron-900 tw-rounded-lg peer-focus:tw-bg-iron-900 tw-ml-7 tw-px-2 peer-focus:tw-px-2 peer-focus:tw-text-primary-400 peer-placeholder-shown:tw-scale-100 \n        peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1"}>By Group Name</label>;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t6 || $[18] !== t8) {
    t10 = <div className="tw-group tw-w-full tw-relative tw-flex-1">{t6}{t7}{t8}{t9}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t4) {
    t11 = <div className="tw-flex tw-flex-col tw-w-full sm:tw-flex-row sm:tw-items-center tw-gap-4 xl:tw-w-1/2 xl:tw-pr-3">{t4}{t10}</div>;
    $[20] = t10;
    $[21] = t4;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== onMyGroups || $[24] !== showMyGroupsButton) {
    t12 = showMyGroupsButton && <button onClick={onMyGroups} type="button" className="tw-whitespace-nowrap tw-text-sm tw-font-semibold tw-inline-flex tw-items-center tw-rounded-lg tw-bg-iron-200 tw-px-3.5 tw-py-2.5 tw-text-iron-800 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-border-0 tw-ring-1 tw-ring-inset tw-ring-white hover:tw-bg-iron-300 hover:tw-ring-iron-300 focus:tw-z-10 tw-transition tw-duration-300 tw-ease-out">My groups</button>;
    $[23] = onMyGroups;
    $[24] = showMyGroupsButton;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== onCreateNewGroup || $[27] !== showCreateNewGroupButton) {
    t13 = showCreateNewGroupButton && <div className="tw-p-[1px] tw-flex tw-rounded-lg tw-bg-gradient-to-b tw-from-primary-400 tw-to-primary-500"><button onClick={onCreateNewGroup} type="button" className="tw-flex tw-items-center tw-whitespace-nowrap tw-border tw-border-solid tw-border-primary-500 tw-rounded-lg tw-bg-primary-500 tw-px-3.5 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm hover:tw-bg-primary-600 hover:tw-border-primary-600 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-600 tw-transition tw-duration-300 tw-ease-out"><svg className="tw-size-5 tw-mr-1.5 -tw-ml-1 tw-flex-shrink-0" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span>Create New</span></button></div>;
    $[26] = onCreateNewGroup;
    $[27] = showCreateNewGroupButton;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <div className="tw-flex tw-gap-3 tw-items-center">{t12}{t13}</div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t11 || $[33] !== t14) {
    t15 = <div className="tw-mt-4 md:tw-mt-6 tw-flex tw-flex-col lg:tw-flex-row tw-w-full lg:tw-items-center tw-justify-between tw-gap-4">{t11}{t14}</div>;
    $[32] = t11;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  return t15;
}